const amountChanged = require('./amountChanged');
const periodChanged = require('./periodChanged');

module.exports = { amountChanged, periodChanged };
